import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm.isIotHubManager ? [_vm._v("\n      " + _vm._s(_vm.formItem.id ? _vm.$i18n_t('NiotaClassic.GWMonitoring.form.titleUpdate') : _vm.$i18n_t('NiotaClassic.GWMonitoring.form.titleCreate')) + "\n    ")] : _vm._e(), _vm._v("\n    " + _vm._s(_vm.formItem.id ? `${_vm.isIotHubManager ? ' - ' : ''}${_vm.formItem.title}` : '') + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_vm.isIotHubManager ? _c('core-button', {
          attrs: {
            "prepend-icon": "fa-save",
            "color": _vm.color,
            "disabled": !_vm.formValid
          },
          on: {
            "click": _vm.createOrUpdateGW
          }
        }, [_vm._v("\n      " + _vm._s(_vm.formItem.id ? _vm.$i18n_t('Common.save') : _vm.$i18n_t('Common.saveAndCreate')) + "\n    ")]) : _vm._e()];
      },
      proxy: true
    }])
  }, [_vm.isSuperSystemAdmin ? [_c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.originatorDialog,
      callback: function ($$v) {
        _vm.originatorDialog = $$v;
      },
      expression: "originatorDialog"
    }
  }, [_vm.originatorDialog ? _c('niota-classic-devices-add-item-selector', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.selectOriginator'),
      "editedItem": _vm.editedItem,
      "plainAccounts": _vm.accounts,
      "type": "originator",
      "fireflyOriginatorsOnly": ""
    },
    on: {
      "close": function ($event) {
        _vm.originatorDialog = false;
      },
      "item-selected": _vm.selectedOriginator
    }
  }) : _vm._e()], 1)] : _vm._e(), _vm.formItem ? _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [!_vm.formItem.id ? _c(VRow, {
    staticClass: "px-0 py-0"
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "text-body-2"
  }, [_c(VSwitch, {
    staticClass: "my-0",
    attrs: {
      "false-value": false,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.importFromFirefly'),
      "inset": "",
      "hide-details": ""
    },
    model: {
      value: _vm.formItem.importFromFirefly,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "importFromFirefly", $$v);
      },
      expression: "formItem.importFromFirefly"
    }
  })], 1)])], 1) : _vm._e(), _vm.formItem.id && _vm.isSuperSystemAdmin ? _c(VRow, {
    staticClass: "px-0 py-0"
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('span', {
    staticClass: "text-body-2"
  }, [_c(VTextField, {
    attrs: {
      "value": `ID ${_vm.formItem.properties.originator.id}`,
      "label": _vm.$i18n_t('NiotaClassic.Devices.table.originator'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "readonly": "",
      "hide-details": "auto",
      "name": "originatorTitle"
    },
    on: {
      "click": function ($event) {
        _vm.originatorDialog = true;
      }
    }
  })], 1)])], 1) : _vm._e(), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.title'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.formItem.title,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "title", $$v);
      },
      expression: "formItem.title"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_vm.formItem.importFromFirefly ? _c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.fireflyGwId'),
      "color": _vm.color,
      "rules": _vm.integerRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "number": "",
      "clearable": "",
      "required": ""
    },
    on: {
      "change": v => {
        _vm.formItem.fireflyGwId = parseInt(v);
      }
    },
    model: {
      value: _vm.formItem.fireflyGwId,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "fireflyGwId", $$v);
      },
      expression: "formItem.fireflyGwId"
    }
  }) : _c(VTextField, {
    class: _vm.formItem.id ? '' : 'required',
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.gwEui'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formItem.id || !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.formItem.eui,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "eui", $$v);
      },
      expression: "formItem.eui"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "outlined": _vm.inpOutlined,
      "color": _vm.color,
      "filled": _vm.inpFilled,
      "items": _vm.accounts,
      "filter": _vm.filterAccounts,
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.account'),
      "rules": _vm.requiredRule,
      "disabled": !_vm.isIotHubManager,
      "item-text": "name",
      "item-value": "id",
      "auto-select-first": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.name))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }], null, false, 2896449550),
    model: {
      value: _vm.formItem.accountId,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "accountId", $$v);
      },
      expression: "formItem.accountId"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "rows": "5",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": `${_vm.$i18n_t('NiotaClassic.GWMonitoring.form.description')} (${_vm.$i18n_t('NiotaClassic.GWMonitoring.form.MdownSupport')})`,
      "autocomplete": "off",
      "hide-details": "auto",
      "disabled": !_vm.isIotHubManager
    },
    model: {
      value: _vm.formItem.description,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "description", $$v);
      },
      expression: "formItem.description"
    }
  })], 1)], 1), _vm.formItem.properties ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.manufacturer'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.properties.manufacturer,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "manufacturer", $$v);
      },
      expression: "formItem.properties.manufacturer"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.serialNr'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.properties.serialNr,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "serialNr", $$v);
      },
      expression: "formItem.properties.serialNr"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.firmwareVersion'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.properties.firmwareVersion,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "firmwareVersion", $$v);
      },
      expression: "formItem.properties.firmwareVersion"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.group'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.properties.group,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "group", $$v);
      },
      expression: "formItem.properties.group"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VSwitch, {
    attrs: {
      "color": _vm.color,
      "value": true,
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.ethernetOrSimcard')
    },
    model: {
      value: _vm.formItem.properties.simCard,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "simCard", $$v);
      },
      expression: "formItem.properties.simCard"
    }
  })], 1), _vm.formItem.properties.simCard ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.simCardNo'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.properties.simCardNo,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "simCardNo", $$v);
      },
      expression: "formItem.properties.simCardNo"
    }
  })], 1) : _vm._e(), !_vm.formItem.properties.simCard ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.ethernet'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.properties.ethernet,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "ethernet", $$v);
      },
      expression: "formItem.properties.ethernet"
    }
  })], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.linkToTool'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.properties.linkToTool,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "linkToTool", $$v);
      },
      expression: "formItem.properties.linkToTool"
    }
  })], 1)], 1) : _vm._e(), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "prepend-inner-icon": "fal fa-siren-on",
      "label": `${_vm.$i18n_t('NiotaClassic.Devices.details.warningLevel')} (> ${_vm.formatLastPacketTime(_vm.formItem.properties.threshold.green)})`,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "rules": _vm.thresholdAlertRule,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.properties.threshold.green,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties.threshold, "green", $$v);
      },
      expression: "formItem.properties.threshold.green"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "prepend-inner-icon": "fal fa-sensor-alert",
      "label": `${_vm.$i18n_t('NiotaClassic.Devices.details.alertLevel')} (> ${_vm.formatLastPacketTime(_vm.formItem.properties.threshold.yellow)})`,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "rules": _vm.thresholdAlertRule,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.properties.threshold.yellow,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties.threshold, "yellow", $$v);
      },
      expression: "formItem.properties.threshold.yellow"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-dtwin-attachments', {
    attrs: {
      "source": "devicetype",
      "attachments": _vm.formItem.properties.attachments || []
    },
    on: {
      "update": _vm.attachmentsUpdated
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('core-address-picker', {
    attrs: {
      "disabled": !_vm.isIotHubManager,
      "addressObject": _vm.initAddrObject,
      "coordinateLookup": _vm.coordinateLookup,
      "mapView": ""
    },
    on: {
      "address-selected": _vm.addressSelected
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };